// alterado - revisado

const mapaFinanceiroCabecalhoList = [
    {
        descricao: '1',
    },
    {
        descricao: '2',
    },
    {
        descricao: '3',
    },
    {
        descricao: '4',
    },
    {
        descricao: '5',
    },
    {
        descricao: 'Nota',
    },
]

export default mapaFinanceiroCabecalhoList